import { ButtonBase, Typography } from "@mui/material";
import { IMG_HAND } from "../../common/common";

interface ChatSendHiProps {
  onWavingHandClick: any;
}

const ChatSendHi = ({ onWavingHandClick }: ChatSendHiProps) => {
  return (
    <ButtonBase className="display-flex flex-direction-row align-items-center cur-pot bg-beau-blue bor-t-r-b-l-4 mar-t-12" sx={{ padding: "8px 16px", justifyContent: "flex-start !important", marginBottom: "-12px" }} onClick={onWavingHandClick}>
      <img src={IMG_HAND} className="box-32 mar-r-8" />
      <Typography className="text-primary-color" variant="body1">
        Send an emoji to say hi!
      </Typography>
    </ButtonBase>
  );
};

export default ChatSendHi;
